module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_maedori@3x-018ca46ac503ae62f94faf4e174e6dea.webp";